import { useCallback } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import SmartMateriaUITable from '../generic/SmartMateriaUITable'
import ButtonBack from '../generic/buttons/floatingButtons/ButtonBack'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import { systemValueLabel } from '../generic/systemValues/systemValueLabel'
import { apiGet } from '../generic/Api_Functions'

const StorageTraceability = () => {
  const { storageId } = useParams()
  const { state } = useLocation()
  const storageName = state?.storageName
  const navigate = useNavigate()
  const { t_ } = useSmartTranslation()

  const columns = [
    {
      name: t_('Date In'),
      field: 'dateIn',
      type: 'datetime'
    },
    {
      name: t_('Date Out'),
      field: 'dateOut',
      type: 'datetime'
    },
    {
      name: t_('Shelve'),
      field: 'shelve',
      edit: false
    },
    {
      name: t_('Row'),
      field: 'rowNumber',
      edit: false
    },
    {
      name: t_('Column'),
      field: 'colNumber',
      edit: false
    },
    {
      name: t_('Resource type'),
      field: 'resourceType.name',
      edit: false,
      render: (row) => systemValueLabel(t_, 'process_resource_type', row.resourceType || {})
    },
    {
      name: t_('Reference code'),
      field: 'resourceReferenceCode',
      edit: false
    },
    {
      name: t_('Reference name'),
      field: 'resourceReferenceName',
      edit: false
    },
    {
      name: t_('Instance code'),
      field: 'resourceInstanceCode',
      edit: false
    },
    {
      name: t_('Instance name'),
      field: 'resourceInstanceName',
      edit: false
    },
    {
      name: t_('Fixture code'),
      field: 'fixtureCode',
      edit: false
    },
    {
      name: t_('Fabrication order'),
      field: 'instanceFoId',
      edit: false
    }
  ]

  const dataFetch = useCallback(async (pagination) => {
    return await apiGet('storageTraceability/pagination/' + storageId, pagination)
  }, [storageId])

  const sortOptions = {
    default: {
      field: 'dateIn',
      direction: -1
    }
  }

  return (
    <div>
      <SmartMateriaUITable
        tableTuneUniqueKey='storageTraceability'
        title={storageName}
        columns={columns}
        dataFetch={dataFetch}
        pageable
        dense
        sortOptions={sortOptions}
      />
      <div style={{ float: 'right' }}>
        <ButtonBack buttonAction={() => navigate('/process/storage')} />
      </div>
    </div>
  )
}

export default StorageTraceability
